

import React from "react";
import * as styles from "./style.module.scss";
import Typography from "@mui/material/Typography";

const NotificationHeading = ({ title, text }) => {
    return (<span className={styles.notificationHeading}>
      <Typography
        component={'span'}
        className={styles?.notificationTitle}
      >
        {title}
      </Typography>
      <Typography
        component={'span'}
        className={styles?.notificationTimeAgo}
      >
        {text}
      </Typography>
    </span>);
};

export default NotificationHeading;
